import type { SupplierResource } from "../../supplier";

export interface SupplierOrderPositionResource {
  id: string;
  gid: string;
  supplier_order_id: string;
  supplier_id: string;
  variant_id: string;
  supplier_variant_number: string;
  variant_ean: string;
  variant_sku: string;
  variant_title: string;
  option_value: string;
  quantity_ordered: string;
  unit_price: string;
  total_price: string;
  old_unit_price: string;
  stock: string;
  amount_of_unit_per_package: string;
  appointment_date: string | null;
  production_days: number | null;
  delivery_days: number | null;
  supplier: SupplierResource;
  errors: string[];
  big_image: string | null;
  small_image: string | null;
  status: string;
}

export enum SupplierOrderPositionStatusEnum {
  Sent = "sent",
  New = "new",
  Processed = "processed",
  IntegrationError = "integration_error",
  PartiallyProcessed = "partially_processed",
  Canceled = "canceled",
}

export interface StoreSupplierOrderPositionRequestBody {
  supplier_order_id: string;
  variant_id: string;
  quantity_ordered: number;
  // todo: position_number will be deleted
  position_number: number;
  unit_price: number;
}

export type UpdateSupplierOrderPositionRequestBody = {
  quantity_ordered?: number;
};
